import { gql } from '@apollo/client'

const UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS_MUTATION = gql`
  mutation updateAllergenIncludedIngredientsDetails($id: ID!, $data: [ID!]) {
    updateAllergenIncludedIngredientsDetails(id: $id, data: $data) {
      id
      updatedAt

      updatedBy {
        id
        name
      }

      includedIngredients {
        id
      }
    }
  }
`

export default UPDATE_ALLERGEN_EXCLUDED_INGREDIENTS_DETAILS_MUTATION
